import { lazy, Suspense } from "react";
import { useRef, useState, useEffect } from "react";

import Automotive from './Gallery/Automotive.jpg';
import Aviation from './Gallery/Aviation.jpg';
import Lifestyle from './Gallery/Lifestyle.jpg';
import Street from './Gallery/Street.jpg';
import Architecture from './Gallery/Architecture.jpg';

const Masonry = lazy(() => import("./Masonry"));
const CircularGallery = lazy(() => import("./CircularGallery"));


const items = [
    {
      id: "1",
      img: Aviation,
      image: Aviation,
      text: "Aviation",
      url: "",
      height: 1000,
    },
    {
      id: "2",
      img: Automotive,
      image: Automotive,
      text:'Automotive',
      url: "",
      height: 650,
    },
    {
      id: "3",
      img: Street,
      image: Street,
      text: "Street",
      url: "",
      height: 700,
    },
    {
      id: "4",
      img: Lifestyle,
      image: Lifestyle,
      text: "Lifestyle",
      url: "z",
      height: 850,
    },
    {
      id: "5",
      img: Architecture,
      image: Architecture,
      text: "Architecture",
      height: 500,
    }
];

function useIsMobile() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 640);

    check(); // run once after mount
    window.addEventListener("resize", check);

    return () => window.removeEventListener("resize", check);
  }, []);

  return isMobile;
}

function LazySection({ children }) {
  const ref = useRef();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setVisible(true);
        observer.disconnect();
      }
    });

    if (ref.current) observer.observe(ref.current);

    return () => observer.disconnect();
  }, []);

  return <div ref={ref}>{visible ? children : <div className="h-[600px]" />}</div>;
}

function GallerySection() {
  const isMobile = useIsMobile();

  return (
    <div id="gallery">
      <LazySection>
        <Suspense>
          
          {isMobile ? (
            <div className="h-[650px] mx-8">
              <CircularGallery
                items={items}
                bend={1}
                textColor="#ffffff"
                borderRadius={0.1}
                scrollEase={0.06}
                scrollSpeed={3.7}
              />
            </div>
          ) : (
            <div className="mx-8 sm:m-16 md:h-screen xl:h-screen 2xl:h-[80vh] relative">
              <Masonry
                items={items}
                ease="power3.out"
                duration={0.1}
                stagger={0.01}
                animateFrom="bottom"
                scaleOnHover
                hoverScale={0.95}
                blurToFocus
                colorShiftOnHover={false}
              />
            </div>
          )}

        </Suspense>
      </LazySection>
    </div>
  );
}

export default GallerySection;